import { createActionGroup, emptyProps, props } from '@ngrx/store';

export const HomeMyHealthPassportHealthRecordActions = createActionGroup({
  source: 'Home My Health Passport Health Record',
  events: {
    Fetch: emptyProps(),
    Reset: emptyProps(),
    'Set Data': props<{ data: Array<any> }>(),
    'Set Error': props<{ error: boolean }>(),
    'Set Loading': props<{ loading: boolean }>()
  }
});
